import { connect } from 'react-redux';
import SiteAbortApprovalsListFinance from './siteAbortApprovalsListFinance';
import { bindActionCreators } from 'redux';
import {
  getSiteAbortApprovalFinance,
  acceptSiteStatusApproval,
  rejectAbortApproval,
  siteStatusCSV
} from 'services/redux/approvals/mrfApprovals/action';

const mapStateToProps = (state) => ({
  approvalList: state.mrfApprovalReducer.siteAbortApprovalFinance,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSiteAbortApprovalFinance,
      acceptSiteStatusApproval,
      rejectAbortApproval,
      siteStatusCSV
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SiteAbortApprovalsListFinance);
